/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Why_Testimonial_2_QuoteInputs */

const es_home_why_testimonial_2_quote = /** @type {(inputs: Home_Why_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexy conectó un mail de hace 8 meses con una presentación actual que resolvió un conflicto contractual. Eso no lo hace una búsqueda normal.`)
};

const en_home_why_testimonial_2_quote = /** @type {(inputs: Home_Why_Testimonial_2_QuoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexy connected an 8-month-old email with a current presentation that resolved a contractual conflict. A normal search doesn't do that.`)
};

/**
* | output |
* | --- |
* | "Nexy connected an 8-month-old email with a current presentation that resolved a contractual conflict. A normal search doesn't do that." |
*
* @param {Home_Why_Testimonial_2_QuoteInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_why_testimonial_2_quote = /** @type {((inputs?: Home_Why_Testimonial_2_QuoteInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Why_Testimonial_2_QuoteInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_why_testimonial_2_quote(inputs)
	return en_home_why_testimonial_2_quote(inputs)
});
export { home_why_testimonial_2_quote as "home.why.testimonial_2_quote" }